export default __webpack_public_path__ + "static/media/coloring_girl_color.7e9df3cd.jpg";